module.exports = __webpack_public_path__ + "static/media/sg.dda65e68.svg";